import React from 'react';
import '../../styles/DownloadBitstopApp/DownloadBistopApp.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { BITSTOP_OPERATOR_NAME } from '../../constants/app';
import { useSelector } from 'react-redux';
import { DownloadApp as translations } from '../../middlewares/i18n';

const DownloadBitstopApp = () => {
  const i18n = useSelector(state => state.i18n)
  const operatorImage = useSelector(state => state.machine.operator_image)
  const operatorName = useSelector(state => state.machine.operator_name)
  const isBitstopOperator = operatorName.includes(BITSTOP_OPERATOR_NAME)
  const showOperatorInfoWithLogo = !isBitstopOperator && operatorImage
  const showOperatorInfoJustName = !isBitstopOperator && !operatorImage
  
  return (
    <div className="download-bitstop-app wrapper" style={{ height: 'auto' }}>
      <div className='rounded-red' />
      <div className="columns">
        <div className="col">
          <h4 className="title">{translations[i18n.language.current].subtitle2}</h4>
          <Link to="download_app" tag="a">{translations[i18n.language.current].downloadCopy} <FontAwesomeIcon icon={faArrowRight} /></Link>
          {showOperatorInfoWithLogo && (
            <div className="operator-info">
              <img src={operatorImage} alt="Operator" className="operator-image" />
              <p>{translations[i18n.language.current].operatedBy} <b>{operatorName}</b></p>
            </div>
          )}
          {showOperatorInfoJustName && (
            <div className="operator-info">
              <p>{translations[i18n.language.current].operatedBy} <b>{operatorName}</b></p>
            </div>
          )}
        </div>
        <div className="col"></div>
      </div>
    </div>
  )
}

export default DownloadBitstopApp;